// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.XTe1hBgZ7ZUSHU {
  display: block;
  flex: 0 0 1px;
  width: 1px;
  margin: var(--ds-space-075, 6px) var(--ds-space-0, 0);
  background-color: var(--ds-border, #091e4224);
}
`, ""]);
// Exports
export var separator = `XTe1hBgZ7ZUSHU`;
export default ___CSS_LOADER_EXPORT___;
